export class COLLECTIONIDSCONSTANTS {
    public static STRUCTURE = 'b0675e9cbaf244cda6199cb460a2bacd'
    public static INSPECTION = '27bc58e55d9f4326846796cfce711039'
    public static PROTECTION = '4e5f78cd5e5f40b4a4b56e2e76f8a0b6'
}